import { NgModule } from '@angular/core';

// xplat
import { AccuservproCoreModule } from '@accuservpro/xplat/web/core';

@NgModule({
  imports: [AccuservproCoreModule],
})
export class CoreModule {}
